import userApi from '../../services/userApi'

const SET_DATA = "SET_DATA"
const SET_PROFILE = "SET_PROFILE"
const SET_USER = "SET_USER"
const SET_TTD_USER = "SET_TTD_USER"
const SET_DESA_USER = "SET_DESA_USER"

const state = {
	profile: null,
	user: null,
	ttdUser: '',
	desaUser: null
}

const mutations = {
	[SET_DATA](state, data) {
		state.data = data
	},
	[SET_PROFILE](state, data) {
		state.profile = data
	},
	[SET_USER](state, data) {
		state.user = data
	},
	[SET_TTD_USER](state, data) {
		state.ttdUser = data
	},
	[SET_DESA_USER](state, data) {
		state.desaUser = data
	}
}

const actions = {
	async fetchUserProfile({ getters, commit }) {
		let token = getters.getAuthService.token
		return await userApi.getProfile(token).then(res => {
			commit(SET_PROFILE, res.data.data)
		})
	},
	async fetchUser({ getters, commit }) {
		let token = getters.getAuthService.token
		return await userApi.getUser(token).then(res => {
			commit(SET_USER, res.data.data)
		})
	},
	async updateProfile({ getters, commit }, data) {
		let token = getters.getAuthService.token
		return await userApi.updateProfile(token, data)
	},
	async updateFotoProfil({ getters, commit }, data) {
		let token = getters.getAuthService.token
		return await userApi.updateFotoProfil(token, data)
	},
	async fetchUserNoCommit({ getters }) {
		let token = getters.getAuthService.token
		return await userApi.getUser(token)
	},
	async fetchUserProfileNoCommit({ getters }) {
		let token = getters.getAuthService.token
		return await userApi.getProfile(token)
	},
	async storeFirebaseTokenWeb({ getters, commit }, data) {
		let token = getters.getAuthService.token
		return await userApi.storeFirebaseTokenWeb(token, data)
	},
	async validateOtp({ getters }, data) {
		let token = getters.getAuthService.token
		return await userApi.validateOtp(token, data)
	},
	async fetchUserTtd({ getters, commit }) {
		let token = getters.getAuthService.token
		return await userApi.fetchUserTtd(token)
	},
	async storeUserTtd({ getters, commit }, data) {
		let token = getters.getAuthService.token
		return await userApi.storeUserTtd(token, data)
	},
	async updateUserTtd({ getters, commit }, data) {
		let token = getters.getAuthService.token
		return await userApi.updateUserTtd(token, data.id, data.form)
	},
	async deleteUserTtd({ getters, commit }, id) {
		let token = getters.getAuthService.token
		return await userApi.deleteUserTtd(token, id)
	},
	async showUmkmUser({ getters }) {
		let token = getters.getAuthService.token
		return await userApi.showUmkmUser(token)
	},
	setUserTtd({ commit }, data) {
		commit(SET_TTD_USER, data)
	},
	setDesaUser({ commit }, data) {
		commit(SET_DESA_USER, data)
	}
}

const getters = {
	getUserProfile: state => {
		return state.profile
	},
	getUser: state => {
		return state.user
	},
	getTtdUser: state => {
		return state.ttdUser
	},
	getDesaUser: state => {
		return state.desaUser
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}